import type { DocsAccessDocument } from '@nadoutong/contracts';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { DOCS_ACCESS_QUERY_KEY, getDocsAccessDocument } from './docs.ts';

/**
 * Session-gated integration-docs document. `staleTime` matches the
 * endpoint's `private, max-age=300`: the body is a document, not live
 * account state.
 */
export function useDocsAccess(): UseQueryResult<DocsAccessDocument> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: DOCS_ACCESS_QUERY_KEY,
    queryFn: ({ signal }) => getDocsAccessDocument(fetchImpl, signal),
    staleTime: 300_000,
  });
}
